import { generateId } from "../api/utils/idGenerator";

// lopp through nested object if value is function then ad id to it
export const addIdToObjectRecursive = (obj) => {
  if (typeof obj === "object") {
    for (let key in obj) {
      if (typeof obj[key] === "function") {
        obj[key].id = generateId();
      }
      if (typeof obj[key] === "object") {
        addIdToObjectRecursive(obj[key]);
      }
    }
  }
};
